import styled from 'styled-components'
import InputLabel from '@material-ui/core/InputLabel'

export const Wrapper = styled.div`
  width: 100%;
`

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
`

export const ContainerFlex = styled.div`
  display: flex;
  margin: 0 0 0 4px;
`
